import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

// Define the navigation data as a single object with named sections
export const navData = {
  // Main navigation items
  main: [
    {
      items: [
        {
          title: 'Places',
          path: paths.dashboard.place.root,
          icon: <Iconify icon="mdi:location" />,
        },
        {
          title: 'Stories',
          path: paths.dashboard.story.root,
          icon: <Iconify icon="ic:baseline-amp-stories" />,
        },
        {
          title: 'Guides',
          path: paths.dashboard.guide.root,
          icon: <Iconify icon="mdi:explore" />,
        },
        // TODO: uncomment to show events in sidebar
        {
          title: 'Events',
          path: paths.dashboard.event.root,
          icon: <Iconify icon="mdi:calendar-month" />,
        },
        {
          title: 'Analytics',
          path: paths.dashboard.analytics.root,
          icon: <Iconify icon="custom:ic-analytics" />,
        },
        {
          title: 'Atlas Analytics',
          path: paths.dashboard.atlasAnalytics.root,
          icon: <Iconify icon="material-symbols:wand-shine" />,
          adminOnly: true,
        },
        {
          title: 'Place Batches',
          path: paths.dashboard.placeBatches.root,
          icon: <Iconify icon="mdi:package-variant-closed" />,
          adminOnly: true,
        },
      ],
    },
  ],

  // Bottom navigation items (Settings)
  bottom: [
    {
      items: [
        {
          title: 'Settings',
          path: paths.dashboard.settings.root,
          icon: <Iconify icon="mdi:cog" />,
        },
      ],
    },
  ],

  // Combined navigation data for components that expect a single array
  all() {
    return [...this.main, ...this.bottom];
  },
};
